import { useI18n } from '@i18n';
import { IconButton, Link, SxProps, Tooltip } from '@mui/material';
import { PropsWithChildren } from 'react';
import { useLocation } from 'react-router-dom';
import { ICONS } from '@/assets/icons';
import { ACADEMY_LINKS } from '@/assets/links';
import Iconify from '@/components/Iconify';
import { PATHS } from '@/routes';

type Props = {
  showTooltip?: boolean;
  deep?: boolean;
  sx?: SxProps;
};

export default function GitBookLink({ children, showTooltip = true, deep = false, sx }: PropsWithChildren<Props>) {
  const { t } = useI18n();
  const route = useLocation();

  // will be used to get the deep link for the gitbook in the future
  // @TODO: move this into a helper function and make it smarter and more readable
  // PRE-5921
  const getDeepLink = () => {
    if (deep) {
      //REPORTING
      if (route.pathname.startsWith(PATHS.reporting.root())) {
        return '/module/reporting';
      }

      //ACTION PLANNING
      if (route.pathname.startsWith(PATHS.actionPlanning.root())) {
        return '/module/massnahmenplanung';
      }

      //DATA COLLECTION
      if (route.pathname.startsWith(PATHS.dataCollection.energySuppliers())) {
        return '/module/datensammlung/emissionszertifikate-verwalten';
      }
      if (route.pathname.startsWith(PATHS.dataCollection.portfolios())) {
        return '/module/einstellungen/portfoliostruktur-verwalten';
      }
      if (route.pathname.startsWith(PATHS.dataCollection.root())) {
        return '/module/datensammlung';
      }

      //SETTINGS
      if (route.pathname.startsWith(PATHS.org.users())) {
        return '/module/einstellungen/nutzer-verwalten';
      }
    }
    return '';
  };

  const href = ACADEMY_LINKS.ACADEMY_HOME + getDeepLink();

  return (
    <Tooltip title={showTooltip ? t('General_Academy-tooltip') : ''} placement="left" arrow>
      <Link href={href} target="_blank" rel="noopener noreferrer" sx={{ ...sx }}>
        {children || (
          <IconButton data-cy="cy-help-center-menu" sx={{ width: 40, height: 40, mr: 1 }}>
            <Iconify icon={ICONS.HELP_CIRCLE} />
          </IconButton>
        )}
      </Link>
    </Tooltip>
  );
}
